var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Dialog', {
    attrs: {
      "title": "Edit Organization Member",
      "show": _vm.isOpen,
      "onClose": _vm.onCancel
    }
  }, [_c('el-form', {
    ref: "formRef",
    attrs: {
      "model": _vm.item,
      "label-width": "180px",
      "label-position": "left",
      "size": "small"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email"
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": "",
      "disabled": ""
    },
    model: {
      value: _vm.item.email,
      callback: function ($$v) {
        _vm.$set(_vm.item, "email", $$v);
      },
      expression: "item.email"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Access Level"
    }
  }, [_c('el-select', {
    model: {
      value: _vm.item.access_level,
      callback: function ($$v) {
        _vm.$set(_vm.item, "access_level", $$v);
      },
      expression: "item.access_level"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "none",
      "label": "none"
    }
  }), _c('el-option', {
    attrs: {
      "value": "member",
      "label": "member"
    }
  }), _c('el-option', {
    attrs: {
      "value": "admin",
      "label": "admin"
    }
  })], 1)], 1), _c('el-divider'), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }